import React from "react";
import { Layout, Menu, Dropdown, Button } from "antd";
import { UserOutlined, DownOutlined } from "@ant-design/icons";

const { Header } = Layout;

export default function HeaderBar() {
  const menu = (
    <Menu
      items={[
        { key: "profile", label: "Profile" },
        { key: "settings", label: "Settings" },
        { key: "logout", label: "Logout" },
      ]}
    />
  );

  return (
    <Header
      style={{
        background: "#fff",
        padding: "0 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ fontWeight: "bold" }}>My Dashboard</div>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button icon={<UserOutlined />}>
          Admin <DownOutlined />
        </Button>
      </Dropdown>
    </Header>
  );
}
